import React from 'react';
import { useThemeContext } from '../../Context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import NorthEastSharpIcon from '@mui/icons-material/NorthEastSharp';
import { DARKCOLORS, LIGHTCOLORS } from '../../Utils/constants';

function ArrowButton({ targetRoute, franchise, franchiseId }) {
    const navigate = useNavigate();
    const { mode } = useThemeContext();

    // Define inline styles
    const buttonStyle = {
        border: 'none',
        color: '#654BF3',
        fontSize: '1em',
        cursor: 'pointer',
        borderRadius: '50%',
        width: '65px',
        height: '65px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.5s ease',
        backgroundColor: mode === 'light' ? LIGHTCOLORS.BackgroundDashboard : DARKCOLORS.BackgroundDashboard
    };

    const iconStyle = {
        fontSize: '1.2em',
        transition: 'color 0.5s ease, transform 0.5s ease', // Changed 'rotate' to 'transform'
    };

    const hoverStyle = {
        backgroundColor: mode === 'light' ? LIGHTCOLORS.Secondary500 : DARKCOLORS.Secondary500,
    };

    // Use state to handle hover
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <button
            style={{
                ...buttonStyle,
                ...(isHovered ? hoverStyle : {}),
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
                navigate(targetRoute, {
                    state: { franchise: franchise, franchiseId: franchiseId }, // Pass franchise text in state
                });
            }}
        >
            <NorthEastSharpIcon
                className='icon-arrow'
                style={{
                    ...iconStyle,
                    transform: isHovered ? 'rotate(45deg)' : 'rotate(0deg)', // Apply rotation based on hover
                }}
            />
        </button>
    );
}

export default ArrowButton;
